import React, { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getOneClient, getAllServices } from "../../redux/actions/authActions";
import { VscEdit } from "react-icons/vsc";
import { IoIosArrowBack } from "react-icons/io";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FiCopy, FiCheck } from "react-icons/fi";

const ViewClient = () => {
	const dispatch = useDispatch();
	const { id } = useParams();
	const navigate = useNavigate();

	const client = useSelector((state) => state.auth.client);

	const [showDefaultPassword, setShowDefaultPassword] = useState(false);
	const [copied, setCopied] = useState(false);

	useEffect(() => {
		async function func() {
			try {
				const token = localStorage.getItem("token");
				if (token) await dispatch(getAllServices(token));
			} catch (err) {
				console.error(err);
			}
		}
		func();
	}, [dispatch, id]);

	const [formData, setFormData] = useState({
		name: "",
		businessName: "",
		email: "",
		clientType: "",
		phoneNumber: "",
		opted: [],
	});

	useEffect(() => {
		if (client) {
			setFormData({
				name: client?.name || "",
				businessName: client?.businessName || "",
				email: client?.email || "",
				clientType: client?.clientType || "",
				phoneNumber: client?.phoneNumber || "",
				opted: client?.services?.map((service) => service.name) || [],
			});
		}
	}, [client]);

	useEffect(() => {
		async function func() {
			try {
				await dispatch(getOneClient(id));
			} catch (err) {
				console.error(err, "error");
			}
		}
		func();
	}, [dispatch, id]);

	const handleSubmit = (e) => {
		e.preventDefault();
		navigate(`/client-management/edit-client/${id}`);
	};

	const handleBack = () => {
		navigate(`/client-management`);
	};

	const cleanName = (formData.name || "").replace(/\s+/g, "");
	const last5 =
		formData.phoneNumber && formData.phoneNumber.length >= 5
			? formData.phoneNumber.slice(-5)
			: formData.phoneNumber || "";
	const defaultPassword = cleanName + last5;

	return (
		<>
			<Sidebar />
			<MainSection>
				<div className="max-w-5xl mx-auto py-2 px-2 pb-16 space-y-6">
					<div className="flex justify-between items-center mb-6">
						<div className="flex items-center gap-3">
							<h1 className="text-2xl sm:text-3xl font-bold text-gray-800">Client Details</h1>
						</div>
						<div className="flex items-center space-x-3">
							<button
								onClick={handleBack}
								className="flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors cursor-pointer"
							>
								<IoIosArrowBack />
								<span>Back</span>
							</button>
							<button
								onClick={handleSubmit}
								className="flex items-center space-x-2 px-4 py-2 rounded-full text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors cursor-pointer"
							>
								<VscEdit />
								<span>Edit Client</span>
							</button>
						</div>
					</div>
					<div className="bg-white rounded-xl shadow-lg p-8 space-y-2">
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
							<div className="relative">
								<label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
									Client Name
								</label>
								<p className="text-gray-900 text-lg font-medium mt-1">
									{formData.name || "N/A"}
								</p>
							</div>
							<div className="relative">
								<label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
									Company Name
								</label>
								<p className="text-gray-900 text-lg font-medium mt-1">
									{formData.businessName || "N/A"}
								</p>
							</div>

							<div className="relative">
								<label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
									Email Address
								</label>
								<p className="text-gray-900 text-lg font-medium mt-1">
									{formData.email || "N/A"}
								</p>
							</div>
							<div className="relative">
								<label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
									Phone Number
								</label>
								<p className="text-gray-900 text-lg font-medium mt-1">
									{formData.phoneNumber || "N/A"}
								</p>
							</div>
							<div className="relative">
								<label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
									Client Type
								</label>
								<p className="text-gray-900 text-lg font-medium mt-1">
									{formData.clientType || "N/A"}
								</p>
							</div>
							<div className="relative">
								<label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
									Default Password
								</label>
								<div className="flex items-center gap-2 mt-1">
									<p className="text-gray-900 text-lg font-mono font-medium select-all">
										{showDefaultPassword
											? defaultPassword || "N/A"
											: defaultPassword
											? "••••••••"
											: "N/A"}
									</p>
									{defaultPassword && (
										<div className="flex items-center space-x-1">
											<button
												type="button"
												onClick={() => setShowDefaultPassword(!showDefaultPassword)}
												className="p-1.5 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
												title={showDefaultPassword ? "Hide password" : "Show password"}
											>
												{showDefaultPassword ? (
													<AiOutlineEyeInvisible size={18} />
												) : (
													<AiOutlineEye size={18} />
												)}
											</button>
											<button
												type="button"
												onClick={() => {
													navigator.clipboard.writeText(defaultPassword);
													setCopied(true);
													setTimeout(() => setCopied(false), 2000);
												}}
												className="p-1.5 text-gray-500 hover:text-blue-600 hover:bg-gray-100 rounded-md transition-colors"
												title={copied ? "Copied!" : "Copy to clipboard"}
											>
												{copied ? (
													<FiCheck size={18} className="text-green-600" />
												) : (
													<FiCopy size={18} />
												)}
											</button>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="border-t border-gray-200 pt-6">
							<label className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
								Services Opted
							</label>
							<div className="flex flex-wrap gap-2 mt-2">
								{formData.opted.length > 0 ? (
									formData.opted.map((service, index) => (
										<span
											key={index}
											className="inline-flex items-center rounded-full bg-blue-100 px-3 py-1 text-sm font-medium text-blue-800"
										>
											{service}
										</span>
									))
								) : (
									<p className="text-gray-500 text-sm">No services selected.</p>
								)}
							</div>
						</div>
					</div>
				</div>
			</MainSection>
		</>
	);
};

export default ViewClient;